import { __extends } from 'tslib';
import web2clientSounds from '@lst/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import { range } from '../../helpers/range.js';
import Spinner from '../Spinner/Spinner.js';
import styles from './Paginator.module.scss.js';

var LEADING_PAGE_RANGE_DISPLAYED = 5;
var TRAILING_PAGE_RANGE_DISPLAYED = 5;
var LEADING_PAGE_RANGE = 4;
var TRAILING_PAGE_RANGE = 4;
var NUM_PAGES_OUTSIDE_RANGE = 1;
var ADJACENT_PAGES = 2;
var ADJACENT_OPPOSITE_RANGE = 3;
var getPaginatorVariables = function (page, pages) {
    var pageNumbers = [];
    var pagesOutsideLeadingRange = [];
    var pagesOutsideTrailingRange = [];
    if (pages <= LEADING_PAGE_RANGE_DISPLAYED + ADJACENT_OPPOSITE_RANGE + 1) {
        pageNumbers = range(1, pages + 1);
    }
    else if (page <= LEADING_PAGE_RANGE) {
        pageNumbers = range(1, LEADING_PAGE_RANGE_DISPLAYED + 1);
        pagesOutsideLeadingRange = range(-ADJACENT_OPPOSITE_RANGE + 1, 1).map(function (n) { return n + pages; });
    }
    else if (page > pages - TRAILING_PAGE_RANGE) {
        pageNumbers = range(pages - TRAILING_PAGE_RANGE_DISPLAYED + 1, pages + 1);
        pagesOutsideTrailingRange = range(0, ADJACENT_OPPOSITE_RANGE).map(function (n) { return n + 1; });
    }
    else {
        pageNumbers = range(page - ADJACENT_PAGES, page + ADJACENT_PAGES + 1);
        pagesOutsideTrailingRange = range(0, NUM_PAGES_OUTSIDE_RANGE).map(function (n) { return n + 1; });
        pagesOutsideLeadingRange = range(0, -NUM_PAGES_OUTSIDE_RANGE, -1).map(function (n) { return n + pages; });
    }
    return {
        pagesOutsideTrailingRange: pagesOutsideTrailingRange,
        pageNumbers: pageNumbers,
        pagesOutsideLeadingRange: pagesOutsideLeadingRange,
    };
};
var Paginator = (function (_super) {
    __extends(Paginator, _super);
    function Paginator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function (event, pageNumber) {
            event.preventDefault();
            if (_this.props.isFetching || _this.props.isDisabled) {
                return;
            }
            var page = pageNumber;
            if (page === undefined) {
                return;
            }
            page = parseInt(page, 10);
            if (page !== _this.props.page) {
                web2clientSounds.playButtonSound();
                _this.props.onSelectedPage(page);
            }
        };
        _this.getDisplayPages = function (page, pagesRange) {
            return pagesRange.map(function (displayPage) {
                var _a;
                var classNameItem = classNames(styles.item, (_a = {},
                    _a[styles.isActive] = displayPage === page,
                    _a));
                return (React.createElement("div", { key: displayPage, className: classNameItem, "data-page": displayPage, onClick: function (e) {
                        _this.onClick(e, displayPage);
                    } }, displayPage));
            });
        };
        return _this;
    }
    Paginator.prototype.getTrailingDots = function () {
        return React.createElement("div", { className: styles.hellip }, "\u2026");
    };
    Paginator.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, page = _c.page, total = _c.total, limit = _c.limit;
        var pages = Math.ceil(total / limit);
        if (pages <= 1)
            return null;
        if (this.props.isFetching) {
            return (React.createElement("div", { className: classNames(styles.container, this.props.className) },
                React.createElement("div", { className: styles.spinner },
                    React.createElement(Spinner, null))));
        }
        var _d = getPaginatorVariables(page, pages), pagesOutsideTrailingRange = _d.pagesOutsideTrailingRange, pageNumbers = _d.pageNumbers, pagesOutsideLeadingRange = _d.pagesOutsideLeadingRange;
        var hasPrevious = page > 1;
        var hasNext = page < pages;
        var outsideTrailingDots = null;
        if (pagesOutsideTrailingRange.length > 0) {
            outsideTrailingDots = this.getTrailingDots();
        }
        var outsideLeadingDots = null;
        if (pagesOutsideLeadingRange.length > 0) {
            outsideLeadingDots = this.getTrailingDots();
        }
        var classNamePrevious = classNames(styles.previous, (_a = {},
            _a[styles.isDisabled] = !hasPrevious,
            _a));
        var classNameNext = classNames(styles.next, (_b = {},
            _b[styles.isDisabled] = !hasNext,
            _b));
        return (React.createElement("div", { className: classNames(styles.container, this.props.className) },
            React.createElement("div", { className: styles.paginator },
                React.createElement("div", { className: classNamePrevious, "data-page": hasPrevious ? page - 1 : null, onClick: function (e) {
                        var pageNumber = hasPrevious ? page - 1 : null;
                        if (pageNumber !== null) {
                            _this.onClick(e, pageNumber);
                        }
                    } }),
                React.createElement("div", { className: styles.list },
                    this.getDisplayPages(page, pagesOutsideTrailingRange),
                    outsideTrailingDots,
                    this.getDisplayPages(page, pageNumbers),
                    outsideLeadingDots,
                    this.getDisplayPages(page, pagesOutsideLeadingRange)),
                React.createElement("div", { className: classNameNext, "data-page": hasNext ? page + 1 : null, onClick: function (e) {
                        var pageNumber = hasNext ? page + 1 : null;
                        if (pageNumber !== null) {
                            _this.onClick(e, pageNumber);
                        }
                    } }))));
    };
    return Paginator;
}(React.PureComponent));

export { Paginator as default };
//# sourceMappingURL=Paginator.js.map
